/**
 * 轉蛋付款彈窗的傳輸接縫，與一番賞的 draw-api.mjs 對稱。DOM、jQuery 全留給
 * 呼叫端，這裡只負責把參數組成 request、送出、回傳 Promise<回應 JSON>。
 *
 * 轉蛋前台端點已全數遷到 REST（namespace `wtoy/v1`），與已 REST 化的
 * `draw/status` / `draw/cancel` 共用同一支 rest-client 與同一把 `wp_rest` nonce。
 */
import { discountFields } from './draw-api.mjs';
import { createRestClient } from './rest-client.mjs';

/**
 * @param {{restBase: string, nonce: string, request?: function}} opts
 * `request(method, route, params)` 預設用 rest-client 送出，測試時可注入假的。
 */
export function createGachaDrawApi({ restBase, nonce, request }) {
    const client = createRestClient({ restBase, nonce, request });

    return {
        discountFields,
        quote(productId, draws, flags) {
            return client.post('/gacha/quote', Object.assign({ product_id: productId, draws }, discountFields(flags)));
        },
        pointsOnlyDraw(productId, draws, flags, billingEmail) {
            return client.post('/gacha/draw', Object.assign({ product_id: productId, draws, billing_email: billingEmail }, discountFields(flags)));
        },
        reserve(payload) {
            return client.post('/gacha/reserve', payload);
        },
        card(payload) {
            return client.post('/gacha/card', payload);
        },
        status(orderId) {
            return client.get('/draw/status', { order_id: orderId });
        },
        cancel(orderId) {
            return client.post('/draw/cancel', { order_id: orderId });
        },
        eligibility(productId) {
            return client.get('/gacha/eligibility', { product_id: productId });
        },
    };
}
